module.exports = __webpack_public_path__ + "static/media/add_sec.67fd7db1.svg";